import React, { useEffect, useState } from "react";
import { Grid, Header, Button } from "semantic-ui-react";
import { reduxForm, Field } from "redux-form";
import { renderOptionField, renderTextField } from "../formcomponents";
import axios from "axios";
import { BaseUrl } from "../formcomponents/Constants";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { userData } from "../store/userData";
const validate = (values) => {
  const errors = {};
  if (!values.companyNameAndPartners) {
    errors.companyNameAndPartners = "Required";
  }
  if (!values.role) {
    errors.role = "Required";
  }
  if (!values.nationality) {
    errors.nationality = "Required";
  }
  if (!values.licenseNum) {
    errors.licenseNum = "Required";
  }
  if (!values.contactNumber) {
    errors.contactNumber = "Required";
  }
  if (!values.emailId) {
    errors.emailId = "Required";
  }

  return errors;
};

const NewFormetCompanyForm = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id, catid } = useParams();
  const userDectail = userData();
  const [buttonDisable, setbuttonDisable] = useState(false);
  useEffect(() => {
    if (id !== "null") {
      getCompanyDetail();
      if (userDectail.userRole != 1) {
        setbuttonDisable(true);
      }
    }
  }, []);

  const getCompanyDetail = () => {
    // axios
    //   .post(BaseUrl + "getSSCompanyDetails", { companyListId: id })
    //   .then((res) => {
    //     console.log("res", res.data);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
    axios
      .post(BaseUrl + "listSSCompany", { categoryId: catid })
      .then((res) => {
        console.log("res", res.data);
        const filteredList = res.data.filter(
          (item) => item.companyListId == id
        );
        console.log("filteredList", filteredList);
        initializeData(filteredList);
      })
      .catch((error) => {});
  };

  const initializeData = (record) => {
    console.log("record", record);
    props.initialize({
      companyListId: record[0].companyListId,
      companyNameAndPartners: record[0].companyNameAndPartners,
      partnersName: record[0].partnersName,
      role: record[0].role,
      nationality: record[0].nationality,
      licenseNum: record[0].licenseNum,
      expiryDate: record[0].expiryDate,
      status: record[0].status,
      contactNumber: record[0].contactNumber,
      emailId: record[0].emailId,
      remarks: record[0].remarks,
      establismentCard: record[0].establismentCard,
      estCardExpiryDate: record[0].estCardExpiryDate,
      // errorCode: 0,
      // errorMessage: null,
    });
  };
  const sumbitForm = async (values) => {
    console.log(`You Values:\n\n${JSON.stringify(values, null, 2)}`);
    await axios
      .post(BaseUrl + "/createSSCompany", values)
      .then((res) => {
        console.log("res", res.data);
        if (res.data.errorCode === 200) {
          Swal.fire("Success", "Work Added", "success");
          navigate(-1);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          Company List
        </Header>
      </Grid.Row>
      <br />
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="companyNameAndPartners"
                label="COMPANY NAME"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="partnersName"
                label=" PARTNERS NAME"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              <Field
                name="role"
                label="Role"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="licenseNum"
                label="License Number"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="expiryDate"
                label="Expiry Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="nationality"
                label="Nationality"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="contactNumber"
                label="Contact Number"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="emailId"
                label="Email Id"
                type="email"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="remarks"
                label="Remarks"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Grid.Row>
        <Grid columns="three">
          <Grid.Row>
            <Grid.Column>
              <Field
                name="status"
                label="Status"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="establismentCard"
                label="Establisment Card"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="estCardExpiryDate"
                label="Expiry"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <br />{" "}
      <Button
        floated="right"
        positive
        disabled={buttonDisable}
        onClick={handleSubmit((values) =>
          sumbitForm({
            ...values,
            categoryId: catid,
          })
        )}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>{" "}
    </div>
  );
};

export default reduxForm({
  form: "NewFormetCompanyForm",
  validate,
})(NewFormetCompanyForm);
